import { AlertMessage } from '@/app/components'
import { Card, Text } from '@/components'
import { ExpirationScheduleEntry } from '@/types/transaction'
import { formatPoints } from '@/utils/rewardPoints'
import { formatRewardDate } from '../../rewards.utils'

/** One row per upcoming expiration date, already clamped and windowed */
export const PointsExpiringSoonCard = ({
  schedule,
}: {
  schedule: ExpirationScheduleEntry[]
}) => {
  if (!schedule.length) return null

  return (
    <Card className="w-full" id="points-expiring-soon">
      <div className="w-full flex flex-col gap-4">
        <Text variant="h3">Points Expiring Soon</Text>
        <AlertMessage variant="info" className="w-full">
          Points expire 1 year after they're earned. These expire in the next 3
          months.
        </AlertMessage>
        <div className="w-full flex flex-col gap-3">
          {schedule.map((entry) => (
            <div
              key={entry.expires_at}
              className="w-full flex flex-row items-center justify-between"
            >
              <Text className="text-sm font-normal text-gray-500">
                {formatRewardDate(entry.expires_at)}
              </Text>
              <Text className="text-sm font-bold text-gray-900 whitespace-nowrap">
                {formatPoints(entry.points)}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </Card>
  )
}
